import { render, staticRenderFns } from "./LeaderBoardComponent.vue?vue&type=template&id=2aa28629&scoped=true"
import script from "./LeaderBoardComponent.vue?vue&type=script&lang=js"
export * from "./LeaderBoardComponent.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardComponent.vue?vue&type=style&index=0&id=2aa28629&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa28629",
  null
  
)

export default component.exports